import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
// import GuideView from "../views/GuideView.vue";
import GuideViewNew from "../views/GuideViewNew.vue";
import HomeView from "../views/HomeView.vue";
import { Haa, OeReportType, OeReportSubType } from '@haa/fwk-h5/lib/index';
const { oeReport } = Haa.util().useOeReport();

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Guide',
        component: GuideViewNew,
        meta: {
            spaceKeys: ['GuideNative', 'GuideBanner'],
        },
    },
    {
        path: "/index",
        name: "Index",
        component: HomeView,
        redirect: '/home',
        children: [
            {
                path: '/home',
                name: 'Home',
                component: () => import('../views/home/home.vue'),
                meta: {
                    spaceKeys: ['HomeInter', 'HomeBanner', 'HomeNative', 'HomeNativeCenter', 'HomeNativeBottom'],
                },
            },
            {
                path: '/hot',
                name: 'Hot',
                component: () => import('../views/home/hot.vue'),
                meta: {
                    spaceKeys: ['HotInter', 'HotBanner', 'HotNative'],
                },
            },
        ],
    },
    {
        path: '/detail',
        name: 'Detail',
        component: () => import('../views/DetailView.vue'),
        meta: {
            spaceKeys: ['DetailInter', 'DetailBanner', 'DetailNative'],
        },
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    const { useParams } = require('@/store/useParams');
    const { params } = useParams();
    if (to.path == '/' && params.skip == 1) {
        oeReport(OeReportType.Action, OeReportSubType.BtnClick, 'Guide', 'skip=1直接上报');
        next('/home');
    } else {
        next();
    }
})

export default router;
